import axios from "../config/axios-neo4j"


export const SchemaRepository = {
  // Create node schema
  createNodeSchema: (label, properties, description = "") => {
    return axios.post('/kb/schema/node', {
      label,
      properties,
      description
    });
  },

  // Create relationship schema
  createRelationshipSchema: (relationshipType, fromLabel, toLabel, properties = {}, description = "") => {
    return axios.post('/kb/schema/relationship', {
      relationship_type: relationshipType,
      from_label: fromLabel,
      to_label: toLabel,
      properties,
      description
    });
  },

  // Get node schema by label
  getNodeSchema: (label) => {
    return axios.get(`/kb/schema/node/${label}`);
  },

  // Get relationship schemas by type
  getRelationshipSchemas: (relationshipType) => {
    return axios.get(`/kb/schema/relationship/${relationshipType}`);
  },

  // Get all node schemas
  getAllNodeSchemas: () => {
    return axios.get('/kb/schema/nodes');
  },

  // Get all relationship schemas
  getAllRelationshipSchemas: () => {
    return axios.get('/kb/schema/relationships');
  },

  // Delete node schema
  deleteNodeSchema: (label) => {
    return axios.delete(`/kb/schema/node/${label}`);
  },

  // Delete relationship schema
  deleteRelationshipSchema: (relationshipType, fromLabel, toLabel) => {
    return axios.delete(`/kb/schema/relationship/${relationshipType}/${fromLabel}/${toLabel}`);
  }
}